import axios, { AxiosRequestConfig } from 'axios'
import { useAuthStore } from '../stores/auth-store'

export const fetchWrapper = {
  get: request('GET'),
  post: request('POST'),
  put: request('PUT'),
  delete: request('DELETE'),
}

function request(method: string) {
  return (url: string, body: object) => {
    const requestOptions: AxiosRequestConfig = {
      method,
      headers: authHeader(url),
    }
    if (body) {
      requestOptions.headers!['Content-Type'] = 'application/json'
      requestOptions.data = JSON.stringify(body)
    }
    return axios(url, requestOptions).then(handleResponse).catch(handleError)
  }
}

function authHeader(url: string) {
  const { user, host } = useAuthStore()
  const isLoggedIn = !!user?.token
  const isApiUrl = url.startsWith(import.meta.env.VITE_API_URL)
  if (isLoggedIn && isApiUrl) {
    return {
      Authorization: `Bearer ${user.token}`,
      'Courstore-X-Host': host,
    }
  } else {
    if (isApiUrl) {
      return {
        'Courstore-X-Host': host,
      }
    } else {
      return {}
    }
  }
}

function handleResponse(response: any) {
  const data = response.data
  if (response.status > 250) {
    const { user, logout } = useAuthStore()
    if ([401, 403].includes(response.status) && user) {
      logout()
    }
    const error: string = (data && data.message) || response.statusText
    console.log(error)
    return Promise.reject(error)
  }
  return data
}

function handleError(error: any) {
  console.log('error')
  console.log(error)
  const { user, logout } = useAuthStore()
  if ([401, 403].includes(error.response.status) && user) {
    logout()
  }
  return Promise.reject(error)
}
